// 登录相关接口
import { http } from '@/http';
const urlIam = process.env.VUE_APP_IAM_BASE_URL
console.log('vxxxx', urlIam)
export default {
  getInfo: params => http.get('/i/info', params),
};

export function handleLoginOut() {
  return http({
    url: urlIam,
    method: 'get',
  });
}
